<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Multiple" size="small" placeholder="请输入"></el-input>
            </div>
            

            <div class="item">
                <div class="label">委托日期:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <el-date-picker
                v-model="conditionData.EndTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>

            <div class="item">
                <div class="label">完成日期:</div>
                <el-date-picker
                v-model="conditionData.comStartTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <el-date-picker
                v-model="conditionData.comEndTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>

            <div class="item">
                <div class="label">案件状态:</div>
                <el-select v-model="conditionData.caseState" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in caseStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            
            <div class="item">
                <div class="label">财务状态:</div>
                <el-select v-model="conditionData.financeState" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in financeStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">是否已结算:</div>
                <el-select v-model="conditionData.IsEndCount" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in IsEndCountList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>

            
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="success" icon="el-icon-download" size="small" @click="getExcel">导出excel</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                <el-table-column
                prop="carInsuranceNo"
                label="案件ID"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="caseType"
                label="案件类型"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="reportNo"
                label="报案号"
                align="center"
                width="220"
                >
                </el-table-column>
                <el-table-column
                prop="carNo"
                label="车牌号"
                align="center"
                width="100"
                >
                </el-table-column>
                


                
                <el-table-column
                prop="insuranceCarriers"
                label="承保公司"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="underwriteInstitution"
                label="展业机构"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="workorganMechanism"
                label="作业机构"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="commissionTime"
                label="委托时间"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="statusTime"
                label="状态时间"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="financeState"
                label="财务状态"
                align="center"
                width="160"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==1">已开票未回款</span>
                    <span v-if="scope.row.financeState==2">已开票部分回款</span>
                    <span v-if="scope.row.financeState==3">回款完成</span>
                    <span v-if="scope.row.financeState==4">已收款未开票</span>
                    <span v-if="scope.row.financeState==5">未开票</span>
                </template>
                </el-table-column>

                <el-table-column
                prop="caseStatus"
                label="案件状态"
                align="center"
                width="120"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.caseStatus==1">案件未完成</span>
                    <span v-if="scope.row.caseStatus==2">已核损待结案</span>
                    <span v-if="scope.row.caseStatus==3">已结案</span>
                </template>
                </el-table-column>

                <el-table-column
                prop="lossStatus"
                label="查勘状态"
                align="center"
                width="140"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.lossStatus==1">已指派未查勘</span>
                    <span v-if="scope.row.lossStatus==2">已查勘待审核</span>
                    <span v-if="scope.row.lossStatus==3">查勘已审核</span>
                    <span v-if="scope.row.lossStatus==5">查勘退回</span>
                    <span v-if="scope.row.lossStatus==6">品管已审核待转录</span>
                    <span v-if="scope.row.lossStatus==7">已转录待保险公司审核</span>
                    <span v-if="scope.row.lossStatus==0">暂无</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="surveyor"
                label="查勘员"
                align="center"
                width="100"
                >
                
                </el-table-column>

                <el-table-column
                prop=""
                label="省"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.province}}</span>
                </template>
                </el-table-column>
                <el-table-column
                prop=""
                label="市"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.city}}</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="addressInfo"
                label="详细地址"
                align="center"
                width="250"
                >
                
                </el-table-column>
               
               
                
                <el-table-column
                prop="assessCost"
                label="车物标准公估费"
                align="center"
                width="130"
                >
                </el-table-column>
                <el-table-column
                prop="actualCost"
                label="车物实收公估费"
                align="center"
                width="130"
                >
                </el-table-column>
                
                <el-table-column
                prop="tagMoney"
                label="标的定损金额"
                align="center"
                width="110"
                >
                </el-table-column>
                <el-table-column
                prop="threeMoney"
                label="三者定损金额"
                align="center"
                width="110"
                >
                </el-table-column>
                
                
                <el-table-column
                prop="peoPleAssessCost"
                label="人伤标准公估费"
                align="center"
                width="130"
                >
                </el-table-column>
                <el-table-column
                prop="actualPPCost"
                label="人伤实收公估费"
                align="center"
                width="130"
                >
                </el-table-column>
               
                <el-table-column
                prop="isYue"
                label="是否广东"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.isYue==0">否</span>
                    <span v-if="scope.row.isYue==1">是</span>
                </template>
                </el-table-column>
                <!-- <el-table-column
                prop="standName"
                label="立项名称"
                align="center"
                width="200"
                >
                </el-table-column> -->
                <el-table-column
                prop="isEndCount"
                label="是否结算"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.isEndCount==0">未结算</span>
                    <span v-if="scope.row.isEndCount==1">已结算</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="remarks"
                label="未决备注"
                align="center"
                width="300"
                >
                </el-table-column>
                <el-table-column
                prop="outRemarks"
                label="结算备注"
                align="center"
                width="300"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="detail(scope.row)">查看详情</el-button>
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceDetail(scope.row)">查看关联立项</el-button>
                    <el-button type="text" icon="el-icon-date" size="mini" @click="dailyList(scope.row)">查看日志</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCaseTip(scope.row)" v-if="isHandle=='1'">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="totalCount"
                    :current-page="conditionData.pageIndex"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="案件详情" width="860px">
            <div class="dialog">
                <div class="item">
                    <div class="label">案件ID:</div>
                    <el-input v-model="detailData.carInsuranceNo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">委托时间:</div>
                    <el-input v-model="detailData.commissionTime" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">承保公司:</div>
                    <el-input v-model="detailData.insuranceCarriers" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">展业机构:</div>
                    <el-input v-model="detailData.underwriteInstitution" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">报案号:</div>
                    <el-input v-model="detailData.reportNo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">车牌号:</div>
                    <el-input v-model="detailData.carNo" size="small" placeholder="" style="width:250px"></el-input>
                </div>

                <div class="item">
                    <div class="label">作业机构:</div>
                    <el-input v-model="detailData.workorganMechanism" size="small" placeholder="" style="width:250px"></el-input>
                </div>

                <div class="item">
                    <div class="label">详细地址:</div>
                    <el-input v-model="detailData.addressInfo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">查勘员:</div>
                    <el-input v-model="detailData.surveyor" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                
                <div class="item">
                    <div class="label">查勘状态:</div>
                    <el-select v-model="detailData.lossStatus" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in lossStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="item">
                    <div class="label">案件类型:</div>
                    <el-input v-model="detailData.caseType" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">案件状态:</div>
                    <el-select v-model="detailData.caseStatus" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in caseStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model="detailData.caseStatus" size="small" placeholder="" style="width:250px"></el-input> -->
                </div>
                <div class="item">
                    <div class="label">财务状态:</div>
                    <el-select v-model="detailData.financeState" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in financeStateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                
                <div class="item">
                    <div class="label">公估费:</div>
                    <el-input v-model="detailData.assessCost" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">实收公估费:</div>
                    <el-input v-model="detailData.actualCost" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                
                <div class="item">
                    <div class="label">标的定损金额:</div>
                    <el-input v-model="detailData.tagMoney" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">三者定损金额:</div>
                    <el-input v-model="detailData.threeMoney" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">状态时间:</div>
                    <el-input v-model="detailData.statusTime" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">人伤公估费:</div>
                    <el-input v-model="detailData.peoPleAssessCost" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">是否广东:</div>
                    <el-select v-model="detailData.isYue" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in isYueList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="item">
                    <div class="label">是否结算:</div>
                    <el-select v-model="detailData.IsEndCount" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in IsEndCountList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                
                <div class="item item-textarea">
                    <div class="label">未决备注:</div>
                    <el-input type="textarea" v-model="detailData.remarks" size="small" placeholder="" style="width:640px"></el-input>
                </div>
                <div class="item item-textarea">
                    <div class="label">结算备注:</div>
                    <el-input type="textarea" v-model="detailData.outRemarks" size="small" placeholder="" style="width:640px"></el-input>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isRelevanceDetail" title="查看关联立项" width="1600px">
            <el-table
                :data="invoiceList"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="立项名称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceNo"
                label="发票号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceCode"
                label="发票编码"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="invoicePrice"
                label="发票金额"
                align="center"
                width="120"
                
                >
                </el-table-column>
                <el-table-column
                prop="actualPrice"
                label="实际收金额"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                label="公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="companyCodeName"
                label="委托公司全称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="状态"
                align="center"
                width="200"
                
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==1">已开票未回款</span>
                    <span v-if="scope.row.financeState==2">已开票部分回款</span>
                    <span v-if="scope.row.financeState==3">回款完成</span>
                    <span v-if="scope.row.financeState==4">已回款未开票</span>
                    <span v-if="scope.row.financeState==7">红冲</span>
                    <span v-if="scope.row.financeState==8">作废</span>
                    <span v-if="scope.row.financeState==5">其他</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="invoicingTime"
                label="开票时间"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="creatTime"
                label="创建时间"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <!-- <el-table-column
                fixed="right"
                label="操作"
                width="150px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceItemDetail(scope.row)">查看详情</el-button>
                </template>
                </el-table-column> -->
            </el-table>
            <div class="page">
                <el-pagination
                    @current-change="handleCurrentInvoiceChange"
                    background
                    layout="prev, pager, next ,sizes ,total"
                    :total="invoiceCount"
                    :current-page="conditionInvoiceData.pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="conditionInvoiceData.pageSize">
                </el-pagination>
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDailyDialog" title="查看日志" width="800px">
            <el-timeline>
                <el-timeline-item :timestamp="item.cDateTime" placement="top" v-for="(item,index) in daily" :key="index">
                <p> 
                    {{item.behavior==0?'插入':''}}
                    {{item.behavior==1?'更新':''}}
                    {{item.behavior==2?'单个关联':''}}
                    {{item.behavior==3?'批量关联':''}}
                    {{item.behavior==4?'取消关联':''}}
                </p>
                </el-timeline-item>
               
            </el-timeline>
        </el-dialog>

    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS,parseTimeD} from '../../../utils/index'
import { provinceAndCityData , CodeToText } from "element-china-area-data";
import {standTermStatus} from '../../../assets/selectList/assetsSelectList'

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            time:'',
            district:'',
            provinceAndCityData:provinceAndCityData,
            title:'',
            isDetailDialog:false,
            totalCount:0,
            conditionData:{
                Multiple:"",
                StartTime:null,
                EndTime:null,
                IsEndCount:null,
                financeState:null,
                caseState:null,
                pageIndex:1,
                pageSize:20,
            },
            tableData:[],
            detailData:{},
            lossStatusList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'已指派未查勘',
                    value:1,
                },{
                    label:'已查勘待审核',
                    value:2,
                },{
                    label:'查勘已审核',
                    value:3,
                },{
                    label:'查勘退回',
                    value:5,
                },{
                    label:'品管已审核待转录',
                    value:6,
                },{
                    label:'已转录待保险公司审核',
                    value:7,
                },
            ],
            caseStatusList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'案件未完成',
                    value:1,
                },{
                    label:'已核损待结案',
                    value:2,
                },{
                    label:'已结案',
                    value:3,
                }
            ],
            casePropertyList:[
                {
                    label:'本地案件',
                    value:1,
                },
                {
                    label:'异地案件',
                    value:0,
                }
            ],
            
            IsEndCountList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'未结算',
                    value:0,
                },{
                    label:'已结算',
                    value:1,
                },
            ],
            isYueList:[
                {
                    label:'否',
                    value:0,
                },{
                    label:'是',
                    value:1,
                },
            ],
            financeStateList:standTermStatus,

            isRelevanceDetail:false,

            conditionInvoiceData:{
                RelationID:null,
                IsJoinCase:null,
                Multiple:"",
                financeState:null,
                StartTime:"",
                EndTime:"",
                CompanyName:"",
                pageIndex:1,
                pageSize:10,
            },
            invoiceList:[],
            invoiceCount:0,
            row:null,

            isDailyDialog:false,

            daily:[
                
            ],
            isHandle:localStorage.getItem('isHandle')
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        
        async dailyList(row){
            this.isDailyDialog = true;
            let res = await api.externalQueryCaseLogs({
                "caseID": row.carInsuranceNo,
                "caseType": 1
            });
            this.daily = res.data.data;
        },
        handleCurrentInvoiceChange(pageIndex){
            this.conditionInvoiceData.pageIndex = pageIndex;
            this.relevanceDetail(this.row);
        },
        async relevanceDetail(row){
            console.log(row);
            this.row = row;
            this.isRelevanceDetail = true;
            this.conditionInvoiceData.RelationID = row.relatedID;
            let res  = await api.getCarList(this.conditionInvoiceData);
            this.invoiceList = res.data.data.entitys;
            this.invoiceCount = res.data.data.pageLen;
            for(let i in this.invoiceList){
                this.invoiceList[i].billingTimeStr = parseTimeD(this.invoiceList[i].billingTime)
            }
        },
        relevanceItemDetail(row){
            localStorage.setItem('editData',JSON.stringify(row));
            const { href } = this.$router.resolve({
                name: "carInsuranceDetail",
                query:{
                    id:row.standProjectId,
                    isDetail:true,
                }
            });
            window.open(href, '_blank');
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            if(this.time){
                this.conditionData.StartTime = parseTimeD(this.time[0]);
                this.conditionData.EndTime = parseTimeD(this.time[1]);
            }
            
            let res  = await api.getCarInsurancePagedList(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.entitys;
            this.totalCount = res.data.data.pageLen;
            for(let i in this.tableData){
                this.tableData[i].commissionTime = parseTimeS(this.tableData[i].commissionTime)
                this.tableData[i].statusTime = parseTimeS(this.tableData[i].statusTime)
            }
            
        },
        selectData(){
            this.conditionData.pageIndex = 1;
            this.loadingData();
        },
        reset(){
            this.time = null;
            this.district = '',
            this.conditionData = {
                Multiple:"",
                StartTime:null,
                EndTime:null,
                IsEndCount:null,
                financeState:null,
                caseState:null,
                pageIndex:1,
                pageSize:20,
            },
            this.loadingData();
        },
        handleCurrentChange(pageIndex){
            this.conditionData.pageIndex = pageIndex;
            this.loadingData();
        },
        
        detail(row){
            this.detailData = row;
            this.isDetailDialog = true;
        },
        async getExcel(){
            let option = {
                Multiple:this.conditionData.Multiple,
                StartTime:this.conditionData.StartTime,
                EndTime:this.conditionData.EndTime,
                IsEndCount:this.conditionData.IsEndCount,
                financeState:this.conditionData.financeState,
            }
            let res = await api.carInsuranceExport(option);
        },


        deleteCaseTip(row){
            this.$confirm('是否删除案件编号：'+row.carInsuranceNo+'?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCase(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async deleteCase(row){
            let res = await api.deleteCarInsurance({
                ID:row.carInsuranceNo
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>

    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 8px 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 7px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            width: 360px;
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
                margin-bottom: 5px;
            }
        }
        .item-textarea{
            width: 760px;
        }
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
        
    }
    /deep/.el-card__body{
        padding: 8px 12px;
    }
    /deep/.el-timeline-item{
        padding-bottom: 10px;
    }
</style>
